export default (value: Date) => {
    const date = new Date(value)
    return date.toLocaleTimeString(['en-GB'], {hour: '2-digit', minute: '2-digit'});
} 